import { MarginOrderDirection, MarginOrderType } from '@swyftx/margin/build/types';

import {
  OpenScenarioLongLimit,
  OpenScenarioLongLimitMobile,
  OpenScenarioLongMarket,
  OpenScenarioLongMarketMobile,
  OpenScenarioLongStop,
  OpenScenarioLongStopMobile,
  OpenScenarioShortLimit,
  OpenScenarioShortLimitMobile,
  OpenScenarioShortMarket,
  OpenScenarioShortMarketMobile,
  OpenScenarioShortStop,
  OpenScenarioShortStopMobile,
} from './illustrations';

export const SYMBOL = 'ETHUSD';

export const DATA_FIELDS = {
  [MarginOrderDirection.Long]: {
    [MarginOrderType.Market]: {
      currentPrice: '1,000.00',
      targetPrice: undefined,
      illustration: (
        <>
          <OpenScenarioLongMarket className='hidden sm:block' />
          <OpenScenarioLongMarketMobile className='block sm:hidden' />
        </>
      ),
    },
    [MarginOrderType.Limit]: {
      currentPrice: '1,000.00',
      targetPrice: '800.00',
      illustration: (
        <>
          <OpenScenarioLongLimit className='hidden sm:block' />
          <OpenScenarioLongLimitMobile className='block sm:hidden' />
        </>
      ),
    },
    [MarginOrderType.Stop]: {
      currentPrice: '1,000.00',
      targetPrice: '1,200.00',
      illustration: (
        <>
          <OpenScenarioLongStop className='hidden sm:block' />
          <OpenScenarioLongStopMobile className='block sm:hidden' />
        </>
      ),
    },
  },
  [MarginOrderDirection.Short]: {
    [MarginOrderType.Market]: {
      currentPrice: '1,000.00',
      targetPrice: undefined,
      illustration: (
        <>
          <OpenScenarioShortMarket className='hidden sm:block' />
          <OpenScenarioShortMarketMobile className='block sm:hidden' />
        </>
      ),
    },
    [MarginOrderType.Limit]: {
      currentPrice: '1,000.00',
      targetPrice: '1,200.00',
      illustration: (
        <>
          <OpenScenarioShortLimit className='hidden sm:block' />
          <OpenScenarioShortLimitMobile className='block sm:hidden' />
        </>
      ),
    },
    [MarginOrderType.Stop]: {
      currentPrice: '1,000.00',
      targetPrice: '800.00',
      illustration: (
        <>
          <OpenScenarioShortStop className='hidden sm:block' />
          <OpenScenarioShortStopMobile className='block sm:hidden' />
        </>
      ),
    },
  },
};
